export const formatCellValue = (rawValue: any, isPricing: boolean = false): string => {
  if (rawValue === null || rawValue === undefined || rawValue === '') return '';

  let numericValue: number | null = null;
  if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
    numericValue = rawValue;
  } else if (typeof rawValue === 'string') {
    const trimmedValue = rawValue.trim();
    const numericPattern = /^[-+]?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/;
    if (numericPattern.test(trimmedValue)) {
      numericValue = Number(trimmedValue.replace(/,/g, ''));
    }
  }

  if (numericValue !== null && isPricing) {
    return numericValue.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return rawValue?.toLocaleString() ?? '';
};

export const formatAxisValue = (value:any) => {
  if (value === 0) return '0';
  
  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  
  if (absValue >= 1000000000) {
    return `${sign}${(absValue / 1000000000).toFixed(1)}B`;
  }
  if (absValue >= 1000000) {
    return `${sign}${(absValue / 1000000).toFixed(1)}M`;
  }
  if (absValue >= 1000) {
    return `${sign}${(absValue / 1000).toFixed(0)}K`;
  }
  return `${sign}${absValue}`;
};

export const COLORS = ['#6196E5', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

export const CHART_COLORS = ['#2C4F81','#457CCF', '#8AABDC' ,'#C3CFE1' ,'#808080' ,'#A1A8B7']

export const getRandomColor = () =>
  COLORS[Math.floor(Math.random() * COLORS.length)];

export const getBarColor = (key:any, entry:any,fields:any,index:number) => {
    const record = fields?.find((f:any) => f.name === key ) || 
      fields?.find((f:any) => f.name === entry.name ) || null;
    const result = evaluateThreshold(entry[key], record?.threshold);
    return result?.color ||  '#6196E5';
};

export const getPieBarColor = (key:any, entry:any,fields:any,index:number) => {
    const threshold = getFieldThreshold(entry.name, fields);
    const result = evaluateThreshold(entry[key], threshold?.threshold);
    return result?.color || CHART_COLORS[index] || '#6196E5';
};

export const getMultiBarColor = (statusColors:any,key:any,entry:any,fields:any,index:number) => {

    const record = fields?.find((f:any) => f.name === key ) || null;
    const result = evaluateThreshold(entry[key], record?.threshold);
    return result?.color || statusColors[key] || CHART_COLORS[index] ;
};

export const getTableColor = (key:any,entry:any,fields:any) => {
    const record = fields?.find((f:any) => f.name === key ) || 
      fields?.find((f:any) => f.name === entry.name ) || null;
    const result = evaluateThreshold(entry[key], record?.threshold);
    return result?.color ;
};

export const evaluateThreshold = (value:any, threshold:any) => {
  if (!threshold?.conditions) return null;

  for (const condition of threshold.conditions) {
    let meetsCondition = false;

    switch (condition.operator) {
      case 'gt': meetsCondition = value > condition.value; break;
      case 'gte': meetsCondition = value >= condition.value; break;
      case 'lt': meetsCondition = value < condition.value; break;
      case 'lte': meetsCondition = value <= condition.value; break;
      case 'eq': meetsCondition = value === condition.value; break;
      case 'between': meetsCondition = value >= condition.min && value <= condition.max; break;
    }

    if (meetsCondition) {
      return {
        color: condition.color,
        backgroundColor: condition.backgroundColor,
        label: condition.label,
      };
    }
  }
  return null;
};


export const evaluatePercentageThreshold = (count:any,total:any, threshold:any) => {
  if (!threshold?.conditions) return null;
  const value = (parseFloat(count)/parseFloat(total)) * 100;

  for (const condition of threshold.conditions) {
    let meetsCondition = false;

    switch (condition.operator) {
      case 'gt': meetsCondition = value > condition.value; break;
      case 'gte': meetsCondition = value >= condition.value; break;
      case 'lt': meetsCondition = value < condition.value; break;
      case 'lte': meetsCondition = value <= condition.value; break;
      case 'eq': meetsCondition = value === condition.value; break;
      case 'between': meetsCondition = value >= condition.min && value <= condition.max; break;
    }

    if (meetsCondition) {
      return {
        color: condition.color,
        backgroundColor: condition.backgroundColor,
        label: condition.label,
      };
    }
  }
  return null;
};

export const getFieldThreshold = (fieldName:any, fields:any) => {
  return fields?.find((f:any) => f.name === fieldName) || null;
};

